import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section id="comprar" className="w-full bg-gradient-to-b from-[#1B2838] to-[#0F1923] py-24 px-6 text-center" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-[#F5E6D0] font-sans" data-id="element-15">
            Si hoy es una de esas noches…
          </h2>

          <p className="text-xl text-[#B8A99A] font-serif max-w-2xl mx-auto" data-id="element-16">
            No necesitas más esperanza. Necesitas una instrucción clara que
            puedas ejecutar con el cerebro a medio gas.
          </p>

          <div className="py-8" data-id="element-17">
            <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-18">
              <span className="text-2xl text-[#B8A99A]/60 line-through font-semibold" data-id="element-19">
                $17.99
              </span>
              <span className="text-5xl font-bold text-[#F5E6D0]" data-id="element-20">$6.39</span>
              <span className="bg-[#E8614D]/20 text-[#E8614D] text-sm font-bold px-3 py-1 rounded-full" data-id="element-21">
                -64% OFF
              </span>
            </div>
          </div>

          <a href="https://www.recursosencalma.com/cart/45721009520813:1" className="w-full md:w-auto bg-[#E8614D] hover:bg-[#D6523F] text-[#1B2838] font-bold py-5 px-10 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-xl shadow-[#E8614D]/20 flex items-center justify-center gap-3 mx-auto no-underline" data-id="element-22">
            <span data-id="element-23">Descarga el kit, imprime la tarjeta</span>
            <ArrowRight className="w-6 h-6" data-id="element-24" />
          </a>

          <p className="text-[#B8A99A] text-sm mt-6 opacity-70" data-id="element-25">
            PDF descargable inmediato. En español.
          </p>
        </motion.div>
      </div>
    </section>;
}